import { render, staticRenderFns } from "./ZoomControlsV2.vue?vue&type=template&id=45664425&scoped=true"
import script from "./ZoomControlsV2.vue?vue&type=script&lang=js"
export * from "./ZoomControlsV2.vue?vue&type=script&lang=js"
import style0 from "./ZoomControlsV2.vue?vue&type=style&index=0&id=45664425&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45664425",
  null
  
)

export default component.exports